import React from 'react';
import NumberFormat from 'react-number-format';
import { withStyles } from '@material-ui/core/styles';

import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx";
import CustomInput from './CustomInput';

function ZarNumberFormat(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        ...values
                    },
                });
            }}
            thousandSeparator=" "
            prefix="R"
        />
    );
}

function UsdNumberFormat(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        ...values
                    },
                });
            }}
            thousandSeparator=" "
            prefix="$"
        />
    );
}

function PoundNumberFormat(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        ...values
                    },
                });
            }}
            thousandSeparator=" "
            prefix="£"
        />
    );
}

function EuroNumberFormat(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        ...values
                    },
                });
            }}
            thousandSeparator=" "
            prefix="€"
        />
    );
}

function NumberOnlyFormat(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        ...values
                    },
                });
            }}
            thousandSeparator=" "
        />
    );
}

function CreditCardNumberFormat(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        ...values
                    },
                });
            }}
            format="#### #### #### ####"
        />
    );
}

function limit(val, max) {
    if (val.length === 1 && val[0] > max[0]) {
        val = '0' + val;
    }

    if (val.length === 2) {
        if (Number(val) === 0) {
            val = '01';

            //this can happen when user paste number
        } else if (val > max) {
            val = max;
        }
    }

    return val;
}

function cardExpiry(val) {
    let month = limit(val.substring(0, 2), '12');
    let year = val.substring(2, 4);

    return month + (year.length ? '/' + year : '');
}

function CreditCardExpiryDateNumberFormat(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        ...values
                    },
                });
            }}
            format={cardExpiry}
            placeholder="MM/YY"
            mask={['M', 'M', 'Y', 'Y']}
        />
    );
}

class NumberMaskInput extends React.Component {
    render() {

        const { classes, inputProps, type, ...rest } = this.props;

        var NewInputComponent = ZarNumberFormat;

        switch (type) {
            case "credit-card":
                NewInputComponent = CreditCardNumberFormat;
                break;
            case "credit-card-expiry":
                NewInputComponent = CreditCardExpiryDateNumberFormat;
                break;
            case "zar":
                NewInputComponent = ZarNumberFormat;
                break;
            case "number":
                NewInputComponent = NumberOnlyFormat;
                break;
            case "usd":
                NewInputComponent = UsdNumberFormat;
                break;
            case "pound":
                NewInputComponent = PoundNumberFormat;
                break;
            case "euro":
                NewInputComponent = EuroNumberFormat;
                break;
        }

        return (
            <CustomInput
                {...rest}
                inputProps={{
                    ...(inputProps || {}),
                    inputComponent: NewInputComponent
                    // InputProps: {
                    //     ...(inputProps ? (inputProps.InputProps || {}) : {}),
                        
                    // }
                }}
            />
        );
    }
}

export default withStyles(customInputStyle)(NumberMaskInput);